import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { CircleCheck, CircleX } from "lucide-react";

export const PolicyLimitsConfirmedIcon = ({
  policyLimitsConfirmed,
}: {
  policyLimitsConfirmed?: boolean;
}) => {
  if (policyLimitsConfirmed) {
    return (
      <TooltipWrapper message="Policy limits confirmed">
        <CircleCheck className="h-4 w-4 text-green-500" />
      </TooltipWrapper>
    );
  }
  return (
    <TooltipWrapper message="Policy limits not confirmed">
      <CircleX className="h-4 w-4 text-yellow-500" />
    </TooltipWrapper>
  );
};
